import { render, staticRenderFns } from "./RouterSection.vue?vue&type=template&id=23e7b9cc&"
import script from "./RouterSection.vue?vue&type=script&lang=js&"
export * from "./RouterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports